import { Skeleton } from '@/shared/components/ui/skeleton';

export function PermissionSetDetailPendingState() {
  return (
    <div className="flex flex-1 flex-col gap-4 p-4 sm:p-6" aria-busy="true">
      <Skeleton className="h-8 w-72" />
      <Skeleton className="h-32 w-full" />
      <Skeleton className="min-h-64 w-full flex-1" />
    </div>
  );
}
